import _ from 'lodash';

const BATCH_FAILED_STATUS = 'FAILED';
const BATCH_CANCELLED_STATUS = 'CANCELLED';
const BATCH_COMPLETE_STATUS = 'COMPLETE';
const BlankIntegrationInstance = require('./../../models/blankIntegrationInstance');
const aeriesType = 'Aeries';
const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]*$/;

class SecureAeriesConnectionController {
  constructor(customerIntegrationsService, config, httpDim, batchService, statusIndicatorService) {
    this.name = 'secureAeriesConnection';
    this.customerIntegrationsService = customerIntegrationsService;
    this.config = config;
    this.httpDim = httpDim;
    this.batchService = batchService;
    this.alphaNumericRegex = ALPHANUMERIC_REGEX;
    this.statusIndicatorService = statusIndicatorService;
    this.isDisabled = false;
    this.userWantsToEditKey = false;
    this.uploadHasSucceeded = false;
    this.schema = {};
    this.forceSync = false;
    this.checkBatchStatus();
    this.getSchema();
  }

  checkBatchStatus() {
    this.statusIndicatorService.getStatus().then(this.onStatusReceived.bind(this));
  }

  onStatusReceived(response) {
    let status = response.data.content ? response.data.content.status : null;
    this.isDisabled = !(status === BATCH_COMPLETE_STATUS || status === BATCH_FAILED_STATUS || status === BATCH_CANCELLED_STATUS);
  }


  getSchema() {
    this.customerIntegrationsService.getSchema(aeriesType)
      .then(this.setSchema.bind(this))
      .then(this.getCustomerIntegrations.bind(this))
      .then(this.onIntegrationsRetrieved.bind(this))
      .catch(this.onIntegrationsRetrievalFailed);
  }

  setSchema(response) {
    this.schema = response.data.content;
    _.each(this.schema.keys, (key, name) => {
      key.instance = new BlankIntegrationInstance(name, aeriesType, key.default);
    });
  }

  getCustomerIntegrations() {
    return this.customerIntegrationsService.getCustomerIntergration(aeriesType);
  }

  onIntegrationsRetrieved(response) {
    let integrations = response.data.content;
    integrations.forEach((integration) => { this.schema.keys[integration.key].instance = integration; });

    if (this.formIsNotValid()) {
      this.setEditingState();
    }
  }

  onIntegrationsRetrievalFailed() {
    console.log('There was an error retrieving your apiKey.');
  }

  setEditingState() {
    this.userWantsToEditKey = true;
  }

  formIsNotValid() {
    var aeriesKey, aeriesUrl;

    if (this.schema.keys) {
      aeriesKey = this.schema.keys.aeries_api;
      aeriesUrl = this.schema.keys.aeries_url;
    }

    return (
      this.apiForm.$invalid ||
      !aeriesKey ||
      !aeriesUrl ||
      !aeriesKey.instance ||
      !aeriesUrl.instance ||
      !aeriesKey.instance.value ||
      !aeriesUrl.instance.value ||
      aeriesKey.instance.value.length !== 32
    );
  }

  syncNow() {
    this.clearErrors();
    this.forceSync = true;
    let integrations = _.map(this.schema.keys, (key) => { return key.instance; });
    return this.customerIntegrationsService.update(integrations)
      .then(this.createBatch.bind(this))
      .catch(this.onIntegrationsUpdateFailure.bind(this));
  }

  onIntegrationsUpdateFailure(err) {
    err.keys.forEach((key) => {
      this.schema.keys[key].error = err.message;
    });
  }

  createBatch() {
    this.userWantsToEditKey = false;
    this.batchService.createBatch(aeriesType, this.forceSync).then(
      this.onSyncCompleted.bind(this),
      this.onSyncFailed.bind(this)
    );
  }

  clearErrors() {
    _.each(this.schema.keys, (key) => { delete key.error; });
  }

  onSyncCompleted() {
    this.uploadHasSucceeded = true;
    this.userWantsToEditKey = false;
    this.forceSync = false;
  }

  onSyncFailed() {
    this.updateHasFailed = true;
    this.forceSync = false;
    console.log('Your sync has failed!');
  }

}

SecureAeriesConnectionController.$inject = ['customerIntegrationsService', 'config', 'httpDim', 'batchService', 'statusIndicatorService'];

export default SecureAeriesConnectionController;



// WEBPACK FOOTER //
// ./app/components/secureAeriesConnection/secureAeriesConnection.controller.js